import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/cXKp9Rkioz33aaGnjm78N1/isabellaseventos_3481236553529130104.jpg', 'https://cdn.magicpatterns.com/uploads/aqMBdvvPSc5oHTbamufctB/D_677417-MLA100596465195_122025-O.jpg', 'https://cdn.magicpatterns.com/uploads/5AJymndBC6xn4DCsPPrMok/candybar.dolcevita_3792795228005391074s2026-1-12-20.41.821_story.jpg', 'https://cdn.magicpatterns.com/uploads/u7QNk91rHKBriNNeTX18eU/01_751_394_90.jpg', 'https://cdn.magicpatterns.com/uploads/pwAf3sghKRDES3doqPhVL7/1-1.jpg'];
export function ResultsCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const goToPrevious = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  return <div className="relative max-w-4xl mx-auto" data-id="element-36">
      <div className="relative h-[400px] md:h-[500px] rounded-2xl overflow-hidden shadow-2xl bg-gray-100" data-id="element-37">
        <AnimatePresence mode="wait" data-id="element-38">
          <motion.img key={currentIndex} src={images[currentIndex]} alt={`Ejemplo de decoración ${currentIndex + 1}`} className="w-full h-full object-contain" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-39" />
        </AnimatePresence>

        <button onClick={goToPrevious} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Anterior" data-id="element-40">
          <ChevronLeft className="w-6 h-6 text-gray-800" data-id="element-41" />
        </button>

        <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Siguiente" data-id="element-42">
          <ChevronRight className="w-6 h-6 text-gray-800" data-id="element-43" />
        </button>

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-44">
          {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-45" />)}
        </div>
      </div>
    </div>;
}